module.exports = "./assets/assets/结果公告.e6323c84.docx";